import React from "react";

import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { Checkbox, ListItemText } from "@material-ui/core";
import { i18n } from "../../translate/i18n";

const normalizeWhatsappIds = (value) => {
	if (Array.isArray(value)) {
		return value
			.map((id) => Number(id))
			.filter((id) => !Number.isNaN(id));
	}
	if (typeof value === "string") {
		return value
			.split(",")
			.map((id) => Number(id))
			.filter((id) => !Number.isNaN(id));
	}
	return [];
};

const TicketsWhatsappSelect = ({
	whatsapps,
	selectedWhatsappIds = [],
	onChange,
}) => {
	const normalizedSelectedWhatsappIds = normalizeWhatsappIds(selectedWhatsappIds);

	const handleChange = (e) => {
		const { value } = e.target;
		const normalized = normalizeWhatsappIds(value);
		onChange(normalized);
	};

	return (
		<div style={{ width: "100%", marginTop: -4 }}>
			<FormControl fullWidth margin="dense">
				<Select
					multiple
					displayEmpty
					variant="outlined"
					value={normalizedSelectedWhatsappIds}
					onChange={handleChange}
					MenuProps={{
						anchorOrigin: {
							vertical: "bottom",
							horizontal: "left",
						},
						transformOrigin: {
							vertical: "top",
							horizontal: "left",
						},
						getContentAnchorEl: null,
					}}
					renderValue={() => i18n.t("ticketsWhatsappSelect.placeholder")}
				>
					{whatsapps?.length > 0 &&
						whatsapps.map(whatsapp => (
							<MenuItem dense key={whatsapp.id} value={whatsapp.id}>
								<Checkbox
									style={{
										color: "#25D366",
									}}
									size="small"
									color="primary"
									checked={normalizedSelectedWhatsappIds.indexOf(whatsapp.id) > -1}
								/>
								<ListItemText primary={whatsapp.name} />
							</MenuItem>
						))}
				</Select>
			</FormControl>
		</div>
	);
};

export default TicketsWhatsappSelect;
